import { QueryClient } from "@tanstack/react-query";

/**
 * TanStack Query istemcisi ve stale-time ayarları.
 *
 * ⚠️ Bu modül BİLEREK `main.tsx`'ten AYRI: `main.tsx` uygulamanın giriş noktası,
 * yani import edildiği anda `createRoot()` + `render()` + CSS + service-worker
 * kaydı YAPAR. `queryClient` oradan export edilirken onu import eden her sayfa
 * (home, gallery, rsvp, layout, activity-toast) tüm bootstrap'i de sürüklüyordu
 * — bu yüzden hiçbir sayfa test ortamında import EDİLEMİYORDU (`#root` yok →
 * "Cannot read properties of null"). Testler bunu `vi.mock("../../main")` ile
 * örtüyordu, yani sorun görünmüyordu ama duruyordu.
 *
 * Yan etkisiz olduğu için `lib/wedding-routes.ts` yedi sayfayı da güvenle
 * statik import edebiliyor → import-time güvenliği testle kanıtlanabiliyor (B4).
 */
export const staleTimes = {
  default:  Number(import.meta.env.VITE_STALETIME_DEFAULT  ?? 60_000),
  rsvp:     Number(import.meta.env.VITE_STALETIME_RSVP     ?? 300_000),
  media:    Number(import.meta.env.VITE_STALETIME_MEDIA    ?? 120_000),
  activity: Number(import.meta.env.VITE_STALETIME_ACTIVITY ?? 30_000),
  comments: Number(import.meta.env.VITE_STALETIME_COMMENTS ?? 120_000),
  albums:   Number(import.meta.env.VITE_STALETIME_ALBUMS   ?? 300_000),
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: staleTimes.default,
      gcTime: 5 * 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: true,
    },
  },
});
